import { gql, TypedDocumentNode } from '@common/hooks';
import {
  LoadBalancingWorkerSkillsQueryCgResponse,
  LoadBalancingWorkerSkillsQueryVariables,
} from '@common/graphql';

export const LOAD_BALANCING_WORKER_SKILLS_QUERY: TypedDocumentNode<
  LoadBalancingWorkerSkillsQueryCgResponse,
  LoadBalancingWorkerSkillsQueryVariables
> = gql`
  query LoadBalancingWorkerSkills(
    $id: ID!
    $scheduleGroupId: ID!
    $on: ISO8601Date!
  ) {
    loadBalancingWorker(id: $id, serviceLineId: $scheduleGroupId) {
      id
      skills(on: $on) {
        id
        name
      }
    }
  }
`;
